export default __webpack_public_path__ + "static/29114-1010d736917ce50e241e273c63886cbb.jpg";